import { useEffect, useState } from "react";
import "./Hero.scss";
import ButtonSecondary from "../../components/shared/ButtonSecondary";
import HeroCrystal from "../../assets/images/hero-crystal.png";
import CrystalScene from "../../components/Home/CrystalScene";

export default function Hero() {
	const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
	const [isDesktop, setIsDesktop] = useState(false);
	const [scrollPosition, setScrollPosition] = useState(0);

	useEffect(() => {
		const checkDevice = () => {
			setIsDesktop(
				!("ontouchstart" in window) &&
					!navigator.maxTouchPoints &&
					!navigator.msMaxTouchPoints
			);
		};

		checkDevice();
		window.addEventListener("resize", checkDevice);
		return () => window.removeEventListener("resize", checkDevice);
	}, []);

	useEffect(() => {
		if (isDesktop) {
			const handleMouseMove = (event) => {
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;
				const relativeX = (event.clientX / windowWidth - 0.5) * 2;
				const relativeY = (event.clientY / windowHeight - 0.5) * 2;
				setMousePosition({ x: relativeX, y: relativeY });
			};

			window.addEventListener("mousemove", handleMouseMove);
			return () =>
				window.removeEventListener("mousemove", handleMouseMove);
		} else {
			// Mobile scroll handling
			const handleScroll = () => {
				const scrollMax = 170;
				const currentScroll = window.scrollY > scrollMax ? scrollMax : window.scrollY;


				// Convert scroll position to -1 to 1 range
				const relativeX = ((currentScroll / scrollMax) * 2 - 1) / 2;
				setMousePosition({ x: relativeX, y: 0 }); // Keep y at 0 for mobile
				setScrollPosition(currentScroll);
			};

			window.addEventListener("scroll", handleScroll);
			return () => window.removeEventListener("scroll", handleScroll);
		}
	}, [isDesktop]);

	const getShadowStyle = (color = "rgba(255, 255, 255, 0.25)") => {
		const maxOffset = 10;
		const shadowX = -mousePosition.x * maxOffset;
		const shadowY = -mousePosition.y * maxOffset;
		return {
			"--shadow-x": `${shadowX}px`,
			"--shadow-y": `${shadowY}px`,
		};
	};

	return (
		<>
			<div className="hero">
				<div className="hero-content-wrapper content-wrapper-lg">
					<div className="hero-content">
						<span
							className="hero-title title-1"
							style={getShadowStyle()}
						>
							UNLOCK
						</span>
						<span
							className="hero-title title-2"
							style={getShadowStyle()}
						>
							Market
						</span>
						<span
							className="hero-title title-3"
							style={getShadowStyle()}
						>
							Insights
						</span>
						<span
							className="hero-title title-4"
							style={getShadowStyle()}
						>
							With
						</span>
						<span
							className="hero-title title-5"
							style={getShadowStyle()}
						>
							AURAI
						</span>
						<span className="hero-desc desc-1">
							Your Intelligent
						</span>
						<span className="hero-desc desc-2">Digital Oracle</span>
						<div className="hero-bg">
							<CrystalScene />
						</div>
						<div className="hero-cta">
							<ButtonSecondary
								className="about-btn pulse-effect"
								href="https://aur-ai.gitbook.io/aurai"
							>
								About Aur AI
							</ButtonSecondary>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
